import { PayPalButtons } from "@paypal/react-paypal-js"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { createPayPalOrder, capturePayPalOrder } from "store/payment-provider"
import { useNavigate } from "react-router-dom"
import { routes } from "router"
import { oldRoutes } from "router/old-routes"
import { toaster } from "components/common/Toast"
import { useTranslation } from "react-i18next"

const PaypalPayment = ({ bookingId, bookingUuid }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { loading: isCaptureLoading } = useSelector((state) => state.paymentProvider.capturePayPalOrder)
  const userRole = useSelector((state) => state.user.role)
  const { loading: isCreateLoading } = useSelector((state) => state.paymentProvider.createPayPalOrder)

  const createOrder = () => {
    return dispatch(createPayPalOrder({ trip_booking_id: bookingId })).then((res) => res?.order_id)
  }

  const onApprove = (data) => {
    if (!data?.orderID) return
    dispatch(capturePayPalOrder({ order_id: data.orderID, trip_booking_id: bookingId })).then((res) => {
      if (res?.success) {
        toaster.success(t("booking.paypal_payment_completed"))
        if (userRole === "user") {
          navigate(routes?.clientBookingConfirmation({ id: bookingUuid }))
        } else {
          navigate(oldRoutes?.bookingConfirmation({ id: bookingUuid }))
        }
      }
    })
  }

  const handleCancel = () => {
    toaster.warn(t("booking.paypal_payment_cancelled"))
  }

  const handleError = (error) => {
    toaster.error(error?.message || t("booking.paypal_payment_failed"))
  }

  return (
    <PayPalButtons
      fundingSource="paypal"
      createOrder={createOrder}
      onApprove={onApprove}
      onCancel={handleCancel}
      onError={handleError}
      disabled={isCreateLoading || isCaptureLoading}
      className="mt-m"
    />
  )
}

PaypalPayment.propTypes = {
  bookingId: PropTypes.string,
  bookingUuid: PropTypes.string
}

export default PaypalPayment
